(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1983],{

/***/ 19668:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kishalaya",
      function () {
        return __webpack_require__(34345);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_kishalaya; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/layout/layout.tsx + 22 modules
var layout = __webpack_require__(16559);
;// CONCATENATED MODULE: ./src/assets/images/kishalaya.jpg
/* harmony default export */ var kishalaya = ({"src":"/_next/static/media/kishalaya.62c02dad.jpg","height":400,"width":1263,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAaEAEAAgMBAAAAAAAAAAAAAAABAAIDBBEx/8QAFAEBAAAAAAAAAAAAAAAAAAAAAv/EABcRAQADAAAAAAAAAAAAAAAAAAABElH/2gAMAwEAAhEDEQA/AJqm5sGGtDJypjXgB4MREFYw3//Z"});
// EXTERNAL MODULE: ./src/styles/kishalaya.module.scss
var kishalaya_module = __webpack_require__(77645);
var kishalaya_module_default = /*#__PURE__*/__webpack_require__.n(kishalaya_module);
;// CONCATENATED MODULE: ./src/pages/kishalaya.tsx



swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl,
    swiper_esm/* Autoplay */.pt
]);




var Kishalaya = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (kishalaya_module_default()).csr_banner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: kishalaya,
                    alt: "",
                    width: 2313,
                    height: 923
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (kishalaya_module_default()).table,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "table-responsive",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                                className: "mt-5 table table-bordered",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                colSpan: 4,
                                                className: (kishalaya_module_default()).tab_h,
                                                children: "PROJECT-KISHALAYA"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                colSpan: 4,
                                                className: "text-center",
                                                children: "SENCO GOLD AND DIAMONDS CSR INITIATIVES FOR EDUCATIONAL SUPPORT TO UNDERPRIVILEGED STUDENTS(PRIMARY LEVEL)"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                colSpan: 4,
                                                className: "text-center",
                                                children: "EXECUTED BY P C SEN CHARITABLE TRUST"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "PROJECT INSIGHT"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    colSpan: 4,
                                                    children: "Our humble support to underprivileged students in pursuing their basic education, either by extending one time or monthly financial support, or by donating educational kits and support system"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "DURATION"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    colSpan: 4,
                                                    children: "(2023-24, 2024-25, 2025-26)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "PROJECT"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    colSpan: 4,
                                                    children: "SARADA-NIVEDITA VIDYATAN & PRABHAT-SHANKAR SHISHU UDYAN, in association with Alinan Ramakrishna Vivekananda Yuva Sangha, Alinan, Purba Medinipur"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                className: (kishalaya_module_default()).tab_h,
                                                colSpan: 4,
                                                children: "PROJECT IMPLEMENTATION PLAN"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "SL NO"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "YEAR"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "LOCATION"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "Project Details"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "1"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "2023-24"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Mayachar Island, Mahishadal Block, Purba Medinipur"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Reconstruction of Creche-cum-Pre-Primary Education Centre"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Construction of Prabhat-Shaankar Shishu Udyan, play area of the students of the creche-cum-Pre-Primary Education, just opposite to the Centre."
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Power Breakfast and educational kits and Medical Camp (to be continued in the next financial year)"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                colSpan: 4,
                                                className: (kishalaya_module_default()).tab_h,
                                                children: "ONGOING PROJECTS"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "SL NO"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "YEAR"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "LOCATION"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "Project Details"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "1"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "2023-24"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Anandaa Nagar Development Society, Purulia"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Support to hostel underprivileged students pursuing school and college education under the society"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "2"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Alinan, Purba Medinipur"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Udbadhan Primary School"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "3"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Vivekananda School & Skill Development Centre, Bamon Mollarchawk, South 24 Parganas"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "One time support in Educational Kits etc"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "4"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Shivmandir Seva Pratisthan, Kolkata"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "One time support in Educational Kits etc to an evening school run by Shivmandir Seva Pratisthan"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var pages_kishalaya = (Kishalaya);


/***/ }),

/***/ 77645:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tab_h":"kishalaya_tab_h__Q0wbr","table":"kishalaya_table__Xvlyg","w_50":"kishalaya_w_50__9z9Xj"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8523,4766,5675,9915,2640,3913,536,486,6646,1251,9774,2888,179], function() { return __webpack_exec__(19668); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);